interface BHNumberInputProps {
  className?: string
  currentValue?: number
  onChange: (newValue?: number) => void
  onFocus?: () => void
  onBlur?: () => void
}

function BHNumberInput({
  className,
  currentValue,
  onChange,
  onFocus,
  onBlur,
}: BHNumberInputProps) {
  const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const value = e.target.value
    const isValidValue = /^-?\d*\.?\d*$/.test(value) // Only allow numbers and a single decimal point
    if (isValidValue) {
      const parsedValue = value !== '' ? Number(value) : undefined
      onChange(parsedValue)
    }
  }

  return (
    <input
      className={`pt-2.5 text-right p-2 pr-1 mr-0.5 ${className ?? ''} h-9 max-w-[96px] `}
      type="number"
      inputMode="decimal"
      pattern="[0-9]*"
      value={currentValue === 0 ? undefined : currentValue}
      onChange={handleInputChange}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  )
}

export default BHNumberInput
